module.exports = __webpack_public_path__ + "media/nl_nl_s2_Jasmijn.07f72a1c.oga";